<template>
  <div class="bg-gray">
    <div class="form-content">

      <el-form
          ref="ruleForm"
          label-width="120px"
          class="demo-ruleForm"
      >
        <el-divider>费用信息</el-divider>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="赛事综合服务费" prop="name">
              {{ row.order.memberprice }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="食宿费" prop="name">
              {{ row.order.shisuprice }}
            </el-form-item>
          </el-col>

        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="其他服务费" prop="name">
              {{ row.order.otherprice }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="费用总计" prop="name">
              {{ row.order.total }}
            </el-form-item>
          </el-col>

        </el-row>
        <el-row>
          <el-col class="footer-button">
            <el-button type="primary" @click="submitForm('ruleForm')" :loading="saveLoading">确定提交
            </el-button>
            <el-button @click="resetForm('ruleForm')" plain v-if="false">重置</el-button>
          </el-col>
        </el-row>
      </el-form>


      <PayDialog :show="payDialogShow" scene="sai_baoming" :ids="orderIds" @onPayError="onPayError"
                 @onPaySuccess="onPaySuccess"
                 @onPayClose="onPayClose"/>


    </div>
  </div>
</template>
<style scoped>
.box {
  /*margin-bottom: 1.5rem;*/
}

.fapiao-tip-wrap {
  background: #F3F3F3;
  margin: 0.2rem;
  border-radius: 8px;
  line-height: 36px;
  padding: 0.2rem;
  font-size: 14px;
  color: #666;
}

.savebtn {
  position: fixed;
  bottom: 0;
  padding-bottom: 0.2rem;
  width: 100%;
  z-index: 10;
  display: flex;
  flex: 1;
  flex-direction: row;
  justify-content: space-around;
  background: linear-gradient(180deg, hsla(0, 0%, 100%, 0), #fff);
}


.van-tag {
  width: 55px;
  margin-left: 10px;
  text-align: center;
}

.between {
  justify-content: space-between;
}


</style>
<script>
import Vue from 'vue';
import area from "../../../utils/area";
import validator from "../../../utils/validator";
import PicUploader from '@/components/picker/PicUploader.vue';
import FileUploader from '@/components/picker/FileUploader.vue';

import {
  Cell,
  Field,
  Area,
  Form,
  Divider,
  CellGroup,
  RadioGroup,
  Radio,
  ActionSheet,
  Icon,
  Toast,
  Popup,
  Picker,
  Sidebar,
  SidebarItem,
  Tag,
  Stepper,
  Switch,
  Button
} from 'vant';
import CaipanPicker from '@/components/picker/CaipanPicker.vue';
import FamliyPicker from '@/components/picker/FamliyPicker.vue';

import PayDialog from '@/components/PayDialog.vue';

Vue.use(Cell).use(CellGroup).use(Form).use(Divider).use(Area).use(ActionSheet).use(RadioGroup).use(Radio).use(Icon).use(Toast).use(Popup).use(Picker).use(Sidebar).use(SidebarItem).use(Tag).use(Stepper).use(Field)
    .use(Switch).use(Button);
export default {
  name: 'SaiApplyFormStep2',
  components: {
    [Field.name]: Field,
    PicUploader,
    PayDialog,
    FileUploader,
  },
  data: function () {
    return {
      validator,
      payDialogShow: false,
      saveLoading: false,
      showArea: false,
      areaList: {},
      areaValue: '',
      submitType: '',
      subjectName: '',
      orderIds: [],
      subjectArray: [],
      subjectOptions: [],
      row: {
        order: {}
      },
    }
  },
  filters: {},
  mounted() {
    let that = this;
    that.row.id = this.$route.query.id;
    document.title = '确认费用';
    if (that.row.id) {
      this.fetch();
    }
  },
  watch: {
    formData() {
    }
  },
  destroyed() {
  },
  methods: {
    onQuestion() {
      console.log('onQuestion')
    },

    submitForm(formName) {
      const that = this;
      // 拿到地区的 省市区名称
      that.saveLoading = true;
      that.$api.post('/api/isai/ordersave', that.row, (res) => {
        that.saveLoading = false;

        that.orderIds = res.data.ids;
        that.payDialogShow = true;

      }, (res) => {
        that.$message.error(res.msg);
        that.saveLoading = false;
      })
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    onSubmit(values) {
      console.log('onSubmit-values', values);
      console.log('submitType', this.submitType);

      let that = this;
      console.log(that.formData)
      that.formValidate = true;
      for (let field in that.formData) {

      }
      that.saveLoading = true;

      that.$api.post('/api/isai/ordersave', that.row, (res) => {
        that.saveLoading = false;

        that.orderIds = res.data.ids;
        that.payDialogShow = true;

      }, (res) => {
        Toast.fail(res.msg);
        that.saveLoading = false;
      })
    },
    save(values) {
      this.submitType = 'save';
    },
    onFailed(errorInfo) {
      console.log('failed', errorInfo);
    },
    submit(values) {
      this.submitType = 'submit';
    },
    fetch() {
      let that = this;
      that.$api.post('/api/isai/step5detail', {
        id: that.row.id
      }, (res) => {
        that.row = res.data;
      }, (res) => {
        Toast.fail(res.msg);
      })
    },

    onPayError() {
      let that = this;
      console.log('onPayError 支付失败');
      that.payDialogShow = false;

      that.$toast('支付失败');

      rbLink({
        name: 'ISaiApplyList'
      }, 'replace')

    },
    onPaySuccess() {
      let that = this;
      console.log('onPaySuccess 支付成功');
      that.payDialogShow = false;


      appEvent({
        name: 'saiApplyDetailReload',
        query: {}
      });

      setTimeout(function () {
        rbLink({
          name: 'ISaiApplyFormSuccess',
          query: {
            id: that.row.id
          }
        }, 'replace')

      }, 500);

    },
    onPayClose() {
      let that = this;
      console.log('onPayClose 支付关闭');
      that.payDialogShow = false;


      appEvent({
        name: 'saiApplyDetailReload',
        query: {}
      });

      setTimeout(function () {
        rbLink({
          name: 'ISaiApplyList'
        }, 'replace')

      }, 500);
    }


  }
}
</script>



// WEBPACK FOOTER //
// SaiApplyFormStep5.vue?07d3c2f2